export default __webpack_public_path__ + "static/media/empty_wood_btn.10d58177.png";